import React from 'react'
import { Link } from "react-router-dom";
import "./home.css";
import heroImg from "../../assets/Kurta_pjama_Hero.webp";
import kurta2 from "../../assets/kurta2.jpg"
import kurta3 from "../../assets/kurta3.webp"
import kurta4 from "../../assets/kurta4.jpg"
import main1 from "../../assets/main1.jpg"
import main2 from "../../assets/main2.jpg"
import main3 from "../../assets/main3.jpg"
import main4 from "../../assets/main4.jpg"
import main5 from "../../assets/main5.jpg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faTruck, faUndo, faHeadset, faTags, faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons";
import TypingText from '../../components/TypingText/TypingText';
import AOS from "aos";
import "aos/dist/aos.css";
const Index = () => {
    return (
        <>
            <section class="hero">
                <div class="hero-content">
                    <h1 className='main-text'><TypingText
                        texts={[

                            "Bulk Custom Kurta–Pajama Manufacturing",
                            "High-Quality Fabrics, Fully Customized",
                            "Ideal for Weddings, Events & Retailers",
                            "Crafted for Comfort, Designed for You"
                        ]}
                    /> </h1>
                    <p>Discover premium traditional wear designed for comfort, elegance, and celebration. Perfect for weddings, festivals, and special occasions.</p>
                    <Link to="/customization" className="banner-btn">Style Your Shawl & Shades</Link>
                </div>
                <img src={heroImg} alt="Kurta Pajama" />
            </section>
            <section className="ai-look-feature" data-aos="fade-up" style={{ backgroundImage: `url(${heroImg})` }}>
                <div className="ai-look-container">
                    <div className="ai-look-content">
                        <div className="ai-look-icon">
                            <FontAwesomeIcon icon={faWandMagicSparkles} size="3x" />
                        </div>
                        <h2>Generate Your Perfect AI Look</h2>
                        <p>Experience the future of fashion customization. Our AI-powered tool creates stunning visualizations of your personalized kurta-pajama combinations in seconds. Choose your colors, fabrics, and shawl designs, then watch as AI brings your vision to life.</p>
                        <Link to="/customization" className="ai-look-btn">
                            Try AI Look Generator
                            <span className="arrow">→</span>
                        </Link>
                    </div>
                    <div className="ai-look-visual">
                        <div className="ai-look-preview">
                            <img src={kurta3} alt="AI Generated Look Preview" />
                            <div className="ai-badge">AI Generated</div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="products" id="shop">
                <h2>Featured Kurta Pajamas</h2>
                <div class="product-grid">
                    <div class="product-card" data-aos="fade-up" data-aos-delay="300">
                        <img src={main1} alt="Ivory Kurta" />
                        <div class="product-info">
                            <h3>Maroon Viscose Silk Slim Fit Long Kurta</h3>
                        </div>
                    </div>
                    <div class="product-card" data-aos="fade-up" data-aos-delay="400">
                        <img src={main3} alt="Maroon Kurta" />
                        <div class="product-info">
                            <h3>Black Kurta Pjama with Cream Shawl</h3>
                        </div>
                    </div>

                    <div class="product-card" data-aos="fade-up" data-aos-delay="600">
                        <img src={main4} alt="Beige Kurta" />
                        <div class="product-info">
                            <h3>Blue White Kurta Pajama with Shawl</h3>
                        </div>
                    </div>
                    <div class="product-card" data-aos="fade-up" data-aos-delay="700">
                        <img src={main2} alt="Navy Kurta" />
                        <div class="product-info">
                            <h3>Designer Kurta</h3>
                        </div>
                    </div>
                    <div class="product-card" data-aos="fade-up" data-aos-delay="800">
                        <img src={main5} alt="Maroon Kurta" />
                        <div class="product-info">
                            <h3>Maroon Designer Kurta</h3>
                        </div>
                    </div>
                </div>
            </section>
            <section class="promo-section">
                <div class="promo-box">

                    <img src={kurta3} className='promo20' alt="Crossbody bag" data-aos="zoom-in" data-aos-delay="300" />
                    <div class="promo-text">
                        <h2>Kurta Pajama</h2>
                        <p>From beach to party: Perfect styles for every occasion.</p>
                        <Link to="/customization">Shop Now</Link>
                    </div>
                </div>

                <div class="promo-box promo-height">
                    <img src={kurta4} height={100} className="promo-img" alt="Capsule Collection" data-aos="zoom-in" data-aos-delay="300" />
                    <div class="promo-overlay">
                        <h2>Capsule Collection</h2>
                        <p>Reserved for special occasions</p>
                        <Link to="/customization">Shop Now</Link>
                    </div>
                </div>
            </section>
            <section class="banner">
                <div class="banner-text">
                    <h1>Limited-Time Deals On!</h1>
                    <p>Up to 50% Off Selected Styles. Don't Miss Out.</p>
                    <Link to="/customization" className="btn">Shop Now</Link>
                </div>
                <div class="banner-image">
                    <img data-aos="zoom-in" data-aos-delay="300" src="https://image.suratwholesaleshop.com/data/2022y/October/35897/Traditional-Wear-Black-Embroidery-Work-Cotton-Art-Silk-Kurta-Pajama-2404.jpg" alt="Limited Time Deals" />
                </div>
            </section>
            <section className="shop-instagram">
                <h2>Upcoming Festivals?</h2>
                <p>Elevate your wardrobe with fresh finds today!</p>
                <div class="insta-grid">
                    <img src={kurta2} data-aos="zoom-in" data-aos-delay="300" alt="Look 2" />
                    <img src={heroImg} data-aos="zoom-in" data-aos-delay="400" alt="Look 2" />
                    <img src={kurta3} data-aos="zoom-in" data-aos-delay="500" alt="Look 2" />
                    <img src={kurta4} data-aos="zoom-in" data-aos-delay="600" alt="Look 2" />
                    <img src={main1} data-aos="zoom-in" data-aos-delay="700" alt="Look 2" />
                </div>
            </section>
            <section className="features">
                <Link to="/ReturnsRefundPolicy" className="feature-item" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <FontAwesomeIcon icon={faUndo} size="2x" />
                    <h3>Returns</h3>
                    <p>Review our return policy</p>
                </Link>

                <div className="feature-item">
                    <FontAwesomeIcon icon={faTruck} size="2x" />
                    <h3>Fast Shipping</h3>
                    <p>No extra costs, just the price you see.</p>
                </div>

                <div className="feature-item">
                    <FontAwesomeIcon icon={faHeadset} size="2x" />
                    <h3>24/7 Support</h3>
                    <p>24/7 support, always here just for you.</p>
                </div>

                <div className="feature-item">
                    <FontAwesomeIcon icon={faTags} size="2x" />
                    <h3>Member Discounts</h3>
                    <p>Special prices for our loyal customers.</p>
                </div>
            </section>

        </>

    )
}

export default Index